import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { tools } from "@iyunbao/utils";

import fetchAPI from "../../../utils/fetchAPI";
import {OccResultItem, OccFetchItem, OccProps } from './type';

// import "./index.scss";

const CommonOccupation = (props: OccProps) => {
  const { onOk } = props;
  const [resultData, setResultData] = useState([] as Array<Array<OccResultItem>>);
  useEffect(() => {
    const getCommonUseData = () => {
      fetchAPI
        .post({
          server: "iybtm",
          path: "/sale/v2/occInfo.json",
          data: {
            packId: tools.getParameterByName('packId'),
            // packId: tools.getParameterByName('packId') || '22564',
          }
        })
        .then(({ result, content }) => {
          if (result === "success" && content.success && content.usuallyOcc && Array.isArray(content.usuallyOcc)) {
            try {
              const resultData: Array<Array<OccResultItem>> = [];

              content.usuallyOcc.forEach((item:OccFetchItem) => {
                const selectItem: Array<OccResultItem> = [];

                if (item.parents) {
                  const { parents, ...res } = item;
                  selectItem.push(...parents, res);
                  resultData.push(selectItem);
                }
              });

              setResultData(resultData);
            } catch (err) {
              console.error(err);
            }
          }
        });
    };
    getCommonUseData();
  }, []);

  if (!(resultData && resultData.length)) {
    return null;
  }

  const handleOk = (e: React.MouseEvent<HTMLDivElement>, item:OccResultItem[]) => {
    (e.target as HTMLDivElement).classList.remove('step-occupation-ite-active');
    (e.target as HTMLDivElement).classList.add('step-occupation-ite-active');
    // tips: 为了显示选中瞬间的样式
    const timer = setTimeout(() => {
      clearTimeout(timer);
      onOk(item);
    }, 0);
  };

  return (
    <div className="stack-step-common-box">
      <div className='stack-step-common-title'>常用职业</div>
      <div className="step-occupation-box">
        {resultData.map((item, index) => {
          const cls = classNames({
            "step-occupation-item": true,
            // "step-occupation-ite-active": true
          });
          return (
            <div
              key={`item_${index}`} // eslint-disable-line react/no-array-index-key
              className={cls}
              onClick={(e) => {
                handleOk(e, item);
              }}
            >
              {item[item.length - 1].label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(CommonOccupation);
